export const AlertType = {
    ALERT_START: "alert/ALERT_START",
    ALERT_STOP: "alert/ALERT_STOP",
};